/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("RetailerLimitShowDetailController", [
            "$scope", "$sessionStorage", "model", "FileSaver", "Blob", "$http", "$oidc", "$translate", "$notifications",
            function ($scope, $sessionStorage, model, FileSaver, Blob, $http, oidc, translate, notifications) {

                $scope.$storage = $sessionStorage;

                $scope.list = model;

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.retailerLimitDetail.orderName === orderName) {
                        $scope.$storage.retailerLimitDetail.orderDesc = !$scope.$storage.limitDetail.orderDesc;
                    } else {
                        $scope.$storage.retailerLimitDetail.orderName = orderName;
                        $scope.$storage.retailerLimitDetail.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.retailerLimitDetail.orderName === orderName) {
                        if ($scope.$storage.retailerLimitDetail.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                $scope.downloadFile = function (id) {
                    _downloadFile(id);
                }

                function _downloadFile(id) {
                    return $http.get("/api/invoice/" + item.InvoiceId + "/download", {
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        skipInterceptors: true
                    })
                        .then(function (response) {
                            var contentDisposition = response.headers("content-disposition");
                            var regex = /filename="*([^"].+[^"])"*;/g;
                            var result = regex.exec(contentDisposition);
                            var fileName = result[1];
                            var data = new Blob([response.data], { type: response.headers("content-type") });
                            FileSaver.saveAs(data, fileName);
                        }, function (data) {
                            translate(['InvoiceAttachmentDownloadError.Message', 'InvoiceAttachmentDownloadError.Name'])
                                .then(function (translations) {
                                    notifications.addError(
                                        translations['InvoiceAttachmentDownloadError.Name'],
                                        translations['InvoiceAttachmentDownloadError.Message']
                                    );
                                }, function () {
                                    notifications.addError(
                                        'Error',
                                        'An error occured when downloading attachments'
                                    );
                                })
                        });
                }
            }
        ]);

})();
